// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"checkBox_wrapper__2IIVw","label":"checkBox_label__19z9l","indicator":"checkBox_indicator__2ti9k","disabled":"checkBox_disabled__Q7B0E","filled":"checkBox_filled__2GKAG"};